<template>
  <div class="login">
    <div>
      <div>
        <p>下载九启数界</p>
        <span>发现有趣</span>
      </div>
      <div>
        <p>手机号</p>
        <input @blur='verifyMobile' v-model='userInfo.phoneNumber'  type="tel" maxlength="11" placeholder="请输入账号">
        <span>{{phoneText}}</span>
        <p>验证码</p>
        <input type="text" v-model='userInfo.code' placeholder="请输入验证码" maxlength="6">
        <span @click="countDown" style="color: white" class="verification">{{content}}</span>
        <p>密码</p>
        <input v-model='userInfo.password'  type="text" placeholder="请输入密码">
        <p>确认密码</p>
        <input v-model='confirmPassword'  type="text" placeholder="请确认密码">
          <p>邀请码</p>
          <input type="text" style="color: rgb(128,128,128)" v-model='userInfo.userInviteCode' readonly disabled>
      </div>
      <div>
        <img v-if="agreeRead" @click="changeStatus" style="width: 18px;height: 18px" src="@/assets/image/Group 242.png"  alt="">
        <div v-else @click="changeStatus" :style="{border:(agreeRead ?'' : '1px solid #999999')}"></div>
        <span>已阅读并同意</span><span @click="goDetail('userNotice')">《用户服务协议》</span>
<!--        <span @click="goDetail('policy')">《隐私权政策》</span>-->
      </div>
      <div>
        <button @click="getLogin">注册</button>
      </div>
      <div>
        <button @click="install" v-show="showDownload">下载安装包</button>
      </div>
      <div>
        <button @click="toWebPage" v-show="showDownload && $route.query.origin === 'QrCode'">前往网页版</button>
      </div>
    </div>
    <div v-if="isVX">
      <img src="@/assets/image/share.png">
      <div>
        <p>点击右上角三个点</p>
        <p>选择“使用默认浏览器打开”后下载安装包</p>
      </div>
    </div>
    <div v-if="isVX" @click="isVX=false"></div>
  </div>
</template>

<script>
import {sendSms, verifySms} from '@/api/register'

export default {
  data() {
    return {
      userInfo:{
        phoneNumber:'',
        code:'',
        userInviteCode:'',
        password:''
      },
      confirmPassword:'',
      agreeRead:false,
      content: '获取验证码',
      totalTime: 180,
      canClick: true, //添加canClick
      phoneText:'请输入正确的格式',
      correct:false,
      pupText:'',
      showDownload: false,
      link:'https://apk-download-jdkj-sjxy-rssy.oss-cn-beijing.aliyuncs.com/jdkjapk/jdsc.apk',
      isVX:false
    }
  },
  mounted() {
    this.userInfo.userInviteCode = this.$route.query.code || ''
    if (this.$route.query.origin === 'QrCode') {
      this.userInfo.registerRewardState = 1
      this.showDownload = false
    } else {
      this.userInfo.registerRewardState = 0
      this.showDownload = true
    }
    // selectVersion().then(res=>{
    //   this.link = res.data[0].link
    // })
  },
  methods: {
    changeStatus(){
      this.agreeRead = !this.agreeRead
    },
    getUrl(url){
      let arr = url.split('?');
      let params = arr[1].split('&');
      let obj = {};
      for(let i=0;i<params.length;i++){
        let param = params[i].split('=');
        obj[param[0]] = param[1];
      }
      return obj;
    },
    countDown () {
      if (!this.canClick) return  //改动的是这两行代码
      if(this.correct){
        let smsCode = this.userInfo.phoneNumber + '/SMS_294011364'
        sendSms(smsCode).then((res)=>{
          this.canClick = false
          this.content = this.totalTime + 's后重新发送'
          let clock = setInterval(() => {
            this.totalTime--
            this.content = this.totalTime + 's后重新发送'
            if (this.totalTime < 0) {
              clearInterval(clock)
              this.content = '重新获取验证码'
              this.totalTime = 180
              this.canClick = true  //这里重新开启
            }
          },1000)
        })
      }else{
        this.pupText = '请输入正确的手机号'
      }
    },
    //验证手机号
    verifyMobile(){
      let myreg=/^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/;
      if(!myreg.test(this.userInfo.phoneNumber)){ //验证手机号格式是否正确
        //请输入正确的格式
        this.phoneText = '请输入正确的格式'
        this.correct = false
      }else{
        //成功
        this.phoneText = ''
        this.correct = true
      }
    },
    //验证码登录
    getLogin(){


      if(this.userInfo.code=='' || this.userInfo.phoneNumber=='' || this.userInfo.password=="" || this.confirmPassword == ''){
        //表单不能为空
        this.$message({
          message: '请填写完整信息',
          type: 'warning'
        });
        return
      }
      if(!this.correct){
        this.$message({
          message: '请输入正确的手机号',
          type: 'warning'
        });
        return
      }
      if(this.userInfo.password.length < 6){
        this.$message({
          message: '密码长度不足6位',
          type: 'warning'
        });
        return
      }
      if(this.confirmPassword != this.userInfo.password){
        this.$message({
          message: '两次输入的密码不一致',
          type: 'warning'
        });
        return
      }
      if(this.agreeRead && this.correct && this.userInfo.password){
        verifySms(this.userInfo).then(res=>{
          if(res.code == 200){
            if(res.message == "验证码正确，该号码已注册，请登录"){
              //号码已注册
              this.showDownload = true
              this.scrollToBottom()
              this.$message.error('该账号已注册，请下载APP登录');
            }else{
              this.showDownload = true
              //注册成功
              this.$message({
                message: '注册成功！请点击下载链接下载',
                type: 'success'
              });
            }
            this.scrollToBottom()
            this.userInfo.phoneNumber=''
            this.userInfo.code=''
            this.userInfo.userInviteCode=''
            this.userInfo.password =''
            this.confirmPassword=''
          }else{
            //网络错误
            this.$message.error(res.message);
          }
        })
      }else{
        //请先阅读服务条款
        this.$message({
          message: '请先阅读并同意协议与政策',
          type: 'warning'
        });
      }
    },
    scrollToBottom() {
      setTimeout(() => {
        window.scrollTo({ top: 9999, behavior: 'smooth' });
      }, 500)
    },
    // 跳转H5
    toWebPage() {
      location.href = 'http://h5.jiuqishujie.cn'
    },
    install(){
      if (/micromessenger/.test(navigator.userAgent.toLowerCase())) {
        // 在微信内置浏览器中
        console.log('在微信内置浏览器中');
        this.isVX = true
      } else {
        console.log(navigator.userAgent)
        if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) { //判断iPhone|iPad|iPod|iOS
          window.location.href = `itms-apps://itunes.apple.com/app/6478385125`;
        } else if (/(Android)/i.test(navigator.userAgent)) {  //判断Android
          window.open('http://apk.jiuqishujie.cn/apk/jqsc.apk','_blank')
        } else { //pc
          window.open('http://apk.jiuqishujie.cn/apk/jqsc.apk','_blank')

        };
      }

    },
    goDetail(path){
      this.$router.push('/' + path)
    }
  }
}
</script>

<style scoped lang="scss">
.login{
  width: 100vw;
  min-height: 100vh;
  // // // // // background: linear-gradient(rgba(22,22,22,0.74), rgba(22,22,22, 0.79)),url('~../../static/image/loginBImg.png') no-repeat;
  //background-size: 100% 100%;
  background: linear-gradient(to bottom, #591A98, #240D33, #250E34);
  >div:nth-child(1){
    width: calc(100% - 48px);
    padding: 0px 24px 20px 24px;
    >div:nth-child(1){
      font-family: PingFang SC;
      font-size: 26px;
      font-weight: 600;
      line-height: 42px;
      letter-spacing: 0em;
      text-align: left;
      color: #ffffff;
      padding-top: 30px;
    }
    >div:nth-child(2){
      margin-top: 70px;
      position: relative;
      >p{
        font-family: PingFang SC;
        font-size: 14px;
        font-weight: 500;
        line-height: 12px;
        letter-spacing: 0px;
        color: #C2C2C2;
        margin-top: 24px;
      }
      >input{
        height: 56px;
        width: 70%;
        font-family: PingFang SC;
        background-color: transparent;
        font-size: 18px;
        font-weight: 400;
        line-height: 56px;
        letter-spacing: 0px;
        color: #ffffff;
        border: none;
        border-bottom: #B3B3B3 solid 1px;
        outline: none;
      }
      >span{
        color: red;
        font-size: 12px;
      }
      //.verification{
      //  position: absolute;
      //  right: 0;
      //  top: 124px;
      //  color: #F1F1F1;
      //  font-size: 15px;
      //}
      >p:nth-child(4){
        margin-top: 24px;
      }
      >p:nth-child(7){
        margin-top: 24px;
      }


    }
    >div:nth-child(3){
      width: 100%;
      height: 16px;
      display: flex;
      align-items: center;
      margin-top: 16px;
      font-family: PingFang SC;
      font-size: 14px;
      font-weight: 400;
      line-height: 12px;
      letter-spacing: 0px;
      text-align: center;
      >div{
        width: 15px;
        height: 15px;
        border-radius: 50%;
      }
      >image{
        width: 16px;
        height: 16px;
        vertical-align: middle;
      }
      >span:nth-child(2){
        color: #C5C5C5;
        margin-left: 2px;
      }
      >span:nth-child(3){
        color: #F3E1BD;
      }
      >span:nth-child(4){
        color: #F3E1BD;
      }
    }
    >div:nth-child(4){
      width: 100%;
      margin-top: 60px;
      text-align: center;
      >button{
        width: 100%;
        height: 56px;
        border: #F3E1BD solid 1px;
        background-color: transparent;
        border-radius: 70px;
        line-height: 56px;
        margin-bottom: 16px;
        color: #F3E1BD;
      }
    }
    >div:nth-child(5){
      width: 100%;
      margin-top: 10px;
      text-align: center;
      >button{
        width: 100%;
        height: 56px;
        background-color: #F3E1BD;
        border-radius: 70px;
        line-height: 56px;
        margin-bottom: 16px;
        border: none;
      }
    }
    >div:nth-child(6){
      width: 100%;
      margin-top: 10px;
      text-align: center;
      >button{
        width: 100%;
        height: 56px;
        background-color: #F3E1BD;
        border-radius: 70px;
        line-height: 56px;
        margin-bottom: 16px;
        border: none;
      }
    }
  }
  >div:nth-child(2){
    width: 280px;
    position: fixed;
    top: 0px;
    left: 50%;
    margin-left: -130px;
    z-index: 99999;
    text-align: right;
    >img{
      width: 75px;
      height: 115px;
      transform: rotateZ(40deg);
    }
    >div{
      width: 220px;
      height: 100px;
      background-color: rgba(255,255,255,.8);
      border: black 1px dashed;
      outline-offset: 10px;
      display: flex;
      justify-items: center;
      justify-content: center;
      flex-flow: column;
      border-radius: 15px;
      padding-left: 15px;
      padding-right: 15px;
      >p{
        color: black;
        font-size: 14px;
        line-height: 24px;
        text-align: center;
      }
    }
  }
  >div:nth-child(3){
    position: fixed;
    background-color: rgba(13, 16, 21,.8);
    z-index: 99;
    width: 100vw;
    min-height: 100vh;
    top: 0;
  }
}
</style>
